import { useMediaQuery } from 'react-responsive';
import theme from 'tailwindcss/defaultTheme';

import { FontVariant, FontVariantProps } from '@utils';

export const useResponsiveTextVariant = (
  variant:
    | FontVariant
    | {
        sm?: FontVariant;
        md?: FontVariant;
        lg?: FontVariant;
      },
) => {
  const isMd = useMediaQuery({
    minWidth: theme.screens.md,
  });
  const isLg = useMediaQuery({
    minWidth: theme.screens.lg,
  });

  let currentVariant: FontVariant;
  if (typeof variant === 'string') {
    currentVariant = variant;
  } else if (isLg && variant.lg) {
    currentVariant = variant.lg ?? 'body-16/r'; // Fallback to md or sm if lg is not provided
  } else if (isMd && variant.md) {
    currentVariant = variant.md ?? variant.lg ?? 'body-16/r'; // Fallback to lg or default if md is not provided
  } else {
    currentVariant = variant.sm ?? 'body-16/r'; // Fallback to a default variant if none is provided
  }
  const [sizeVariant, weightVariant] = currentVariant.split('/') as [
    FontVariantProps['variant'],
    FontVariantProps['weight'],
  ];
  return {
    sizeVariant,
    weightVariant,
  } as const;
};
